export enum VacancyStandardsCheck {
  Off = 'off',
  Warning = 'warning',
  Strict = 'strict',
}
